export default __webpack_public_path__ + "static/media/factory__24.95af6a1f.jpg";